export default __webpack_public_path__ + "static/services-851691b9e06f662f523413eecbab669b.png";